import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Importing sub-components
import ServicesHeader from "./ServicesHeader";
import ServicesList from "./ServicesList";
import WhyUs from "./WhyUs";
import ContactUs from "../../../Components/ContactUs";
import SeoHelmet from "../../../Components/SeoHelmet";

gsap.registerPlugin(ScrollTrigger);

export default function ViraPremiumDarkBusiness() {
  const containerRef = useRef(null);

  useEffect(() => {
    // Elegant and smooth animation for revealing elements on scroll
    const ctx = gsap.context(() => {
      gsap.utils.toArray(".reveal-up").forEach((elem) => {
        gsap.fromTo(
          elem,
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 1.2,
            ease: "expo.out",
            scrollTrigger: { trigger: elem, start: "top 85%" },
          },
        );
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <>
      <SeoHelmet
        title="خدمات تخصصی ویرا | مهندسی وب، شبکه و راهکارهای دیجیتال"
        metaDescription="آشنایی با خدمات پریمیوم آژانس ویرا (Vira-tec) شامل توسعه پلتفرم‌های سازمانی، سئوی تکنیکال، معماری شبکه‌های کامپیوتری و تحلیل داده‌های کلان تجاری."
        metaKeywords="خدمات ویرا, طراحی سایت اختصاصی, توسعه نرم‌افزار سازمانی, پیکربندی شبکه, خدمات سئو, دیجیتال مارکتینگ, vira-tec services"
      />

      <Box
        ref={containerRef}
        sx={{
          bgcolor: "",
          color: "#F8FAFC",
          minHeight: "100svh",
          // pb: 15,
          "& *": { direction: "rtl", boxSizing: "border-box" },
        }}
      >
        {/* Global Background: Subtle dark blue gradient glow at the top */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "100vh",
            background:
              "radial-gradient(circle at 50% 0%, rgba(15, 23, 42, 0.8) 0%, transparent 70%)",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />

        {/* 1. Hero / Header Section */}
        <ServicesHeader />

        {/* 2. Services Cards Grid Section */}
        <ServicesList />

        {/* 3. Why Us / Trust Pillars Section */}
        <WhyUs />

        <ContactUs />
      </Box>
    </>
  );
}
